<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />

    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/shera/AboutInstructor.vue'

import TestimonialCompany from '../../components/shera/CompnayTestimonial.vue'
import Landing from '../../components/shera/Landing.vue'
import ProgramInfo from '../../components/shera/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import BasicRequirement from '../../components/shera/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title: 'Your first step to become a SEO Executive',
        paragraph:
          'Upskill presents this assessment only designed for SEO - Executive Take part in this assessment, and get a chance to work at Shera Digital 360  ',
        companyLogo: require('../../assets/shera/logo_small.png'),
        quizLink:
          'https://quiz.upskill.com.bd/assessment/ebc0867e-f695-4815-9f9f-d0780426de7a?public=true&job=Isa_Seo_Shera',
        landingImage: require('../../assets/shera/landing.png'),
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../assets/shera/logo_big.png'),
        info:
          '‘Shera digital 360’ believes in evolving with time. Hence, we deliver technology-driven solutions that would make heads turn. From our scroll-stopping creatives to the remarkable campaign, Shera digital 360 helps brands and nonprofits engage with their rightful audience at the right time and in the proper context. Our services include marketing, branding, advertising, social media, content, design, web, SEO, & PPC. We, as a team, make an extra effort to make sure that every detail of service is done with efficiency..',
        designation: '',

        bgColor: '#B70000',
      },
      programData: {
        headingInfo:
          'SEO Executive  Assessment  consists of approximately 15 MCQs. You are required to pass an assessment test with a minimum 70% of the total score. ',
        seatsInfo:
          'Top 5 Candidates will get the chance to go to the interview round directly after completing the assessment. After getting hired, the candidate will have to give Upskill 33% of first 3 months salary.The starting Salary is 25,000 BDT. So, don’t miss this opportunity as the time is limited!',
        startDate: '06th January',
        cost: 'Free',
        deadline: '07th January',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#00A653',
      },

      companyTestimonial: {
        mainImg: require('../../assets/shera/company.png'),
        name: 'Md. Mehraz Anam ',
        paragraph:
          'Shera Digital 360 is excited to work with upskill and to find the right candidate for the SEO-Executive position. ',
        designation: 'Sr. Visualizer  Shera Digital 360',
        invertedCommaBg: ' #00A653',
      },
      basicRequirement: {
        mainContent: [],
        bgColor: '',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content:
            'It is free, But the hired candidate candidate will have to give Upskill 33% of first 3 months salary.The starting Salary is 25,000 BDT',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Yes, a minimum of 2+years of experience in relevant areas . \n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score  i.e.  out 9 of 15',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at iPAGE?\n',
          content:
            'No, the top 5 students will get a chance to interview at iPAGE  and will get the job depending on their performance in the interview. \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
  },
  created() {
    this.Loaded()
  },
}
</script>
